module.exports = __webpack_public_path__ + "static/media/tmdb.08392f18.svg";